import { Controller } from '@hotwired/stimulus'

export default class ShareLinkController extends Controller {
  static targets = []

  connect() {
  }

  share(event) {
    event.preventDefault();

    if (navigator.share) {
      navigator.share({
        title: "Je viens de découvrir un super projet immobilier dès 1€ sur La Première Brique ! 🚀 Participe dès maintenant en quelques clics. Plus d'infos ici :",
        url: window.location.href
      })
    } else {
      alert('Le partage n’est pas pris en charge sur ce navigateur');
    }
  }
}
